module.exports = __webpack_public_path__ + "img/chargingpoint-fastcharger-realized.d3fc83d1.svg";